// components/TenantLanding/Login/RegisterForms/Professional1.js
import React from "react";

const CAREER_STAGE_OPTIONS = [
  { value: "Aspirant / Graduate", label: "Aspirant / Graduate" },
  { value: "Trainee Surveyor", label: "Trainee Surveyor" },
  { value: "Junior Surveyor", label: "Junior Surveyor" },
  { value: "Independent Surveyor", label: "Independent Surveyor" },
  { value: "Senior / Lead Surveyor", label: "Senior / Lead Surveyor" },
  { value: "Principal / Authority", label: "Principal / Authority" },
];

const EXPERIENCE_BAND_OPTIONS = [
  { value: "0", label: "0 years" },
  { value: "<1", label: "Less than 1 year" },
  { value: "1-3", label: "1–3 years" },
  { value: "3-6", label: "3–6 years" },
  { value: "6-12", label: "6–12 years" },
  { value: "12+", label: "12+ years" },
];

const QUALIFICATION_OPTIONS = [
  { value: "Diploma", label: "Diploma" },
  { value: "Degree", label: "Degree" },
  { value: "Master", label: "Master" },
  { value: "Trade", label: "Trade" },
  { value: "Seagoing certificate", label: "Seagoing certificate" },
  { value: "Other", label: "Other" },
];

const Professional1 = ({
  formData,
  errors,
  loading,
  handleChange,
  handleNext,
  handlePrevious,
  industryOptions,
  scopeOptions,
}) => {
  return (
    <div className="register-stage1-section">
      <h3 className="register-stage1-section__title">
        <span className="register-stage1-section__icon">💼</span>
        Professional Direction
      </h3>
      <p className="register-stage1-section__subtitle">
        Primary industry, scope and career stage.
      </p>

      <div className="register-stage1-form__row">
        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Primary Industry <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="primary_industry"
              className={`register-stage1-form__select ${errors.primary_industry
                  ? "register-stage1-form__select--error"
                  : ""
                }`}
              value={formData.primary_industry}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select an industry</option>

              {industryOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.code} - {option.label}
                </option>
              ))}
            </select>
            {errors.primary_industry && (
              <span className="register-stage1-form__error-text">{errors.primary_industry}</span>
            )}
            <small className="register-stage1-form__help-text">
              Loads relevant discipline options.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Primary Scope <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="primary_scope"
              className={`register-stage1-form__select ${
                errors.primary_scope ? "register-stage1-form__select--error" : ""
              }`}
              value={formData.primary_scope}
              onChange={handleChange}
              disabled={loading || !formData.primary_industry}
            >
              <option value="">
                {!formData.primary_industry
                  ? "Select an industry first"
                  : "Select a scope"}
              </option>

              {scopeOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.code} - {option.scope_name}
                </option>
              ))}
            </select>
            {errors.primary_scope && (
              <span className="register-stage1-form__error-text">{errors.primary_scope}</span>
            )}
            <small className="register-stage1-form__help-text">
              Dependent on primary industry selection.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Career Stage <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="self_declared_career_stage"
              className={`register-stage1-form__select ${errors.self_declared_career_stage ? "register-stage1-form__select--error" : ""}`}
              value={formData.self_declared_career_stage}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select your career stage</option>
              {CAREER_STAGE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.self_declared_career_stage && (
              <span className="register-stage1-form__error-text">{errors.self_declared_career_stage}</span>
            )}
            <small className="register-stage1-form__help-text">
              Initial workflow and mentoring route. Final Qualion level will be verified later.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">Current Job Title</label>
            <input
              type="text"
              name="current_job_title"
              className="register-stage1-form__input"
              value={formData.current_job_title}
              onChange={handleChange}
              placeholder="Coating Inspector"
              disabled={loading}
            />
            <small className="register-stage1-form__help-text">
              Will be standardised later through role taxonomy.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Total Experience Band <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="initial_experience_band"
              className={`register-stage1-form__select ${errors.initial_experience_band ? "register-stage1-form__select--error" : ""}`}
              value={formData.initial_experience_band}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select experience band</option>
              {EXPERIENCE_BAND_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.initial_experience_band && (
              <span className="register-stage1-form__error-text">{errors.initial_experience_band}</span>
            )}
            <small className="register-stage1-form__help-text">
              Used for initial form routing. Will be calculated accurately in Stage 2.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Highest Qualification <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="highest_qualification_level"
              className={`register-stage1-form__select ${errors.highest_qualification_level ? "register-stage1-form__select--error" : ""}`}
              value={formData.highest_qualification_level}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select highest qualification</option>
              {QUALIFICATION_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.highest_qualification_level && (
              <span className="register-stage1-form__error-text">{errors.highest_qualification_level}</span>
            )}
            <small className="register-stage1-form__help-text">
              Initial competency routing. Detailed education entered in Stage 2.
            </small>
          </div>
        </div>
      </div>

      <div className="register-stage1-form__actions">
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--outline"
          onClick={handlePrevious}
          disabled={loading}
        >
          ← Back
        </button>
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--primary"
          onClick={handleNext}
          disabled={loading}
        >
          Continue →
        </button>
      </div>
    </div>
  );
};

export default Professional1;